import React, { forwardRef } from 'react'
import { useCallback } from 'sb-hooks'
import cx from 'classnames'

import { Icon } from 'components/_new/ui'
import { Field, FormularField } from 'components/_new/forms'
import type { FieldProps } from 'components/_new/forms'

import s from './SearchField.scss'


export type SearchFieldProps = FieldProps & {
  onSubmit?: React.FormEventHandler
  isFormular?: boolean
}

const SearchField = forwardRef<HTMLInputElement, SearchFieldProps>((props, ref) => {
  const { className, beforeNode: customBeforeNode, isFormular, onSubmit, ...rest } = props

  const beforeNode = customBeforeNode || (
    <Icon name="search" className={s.icon} />
  )

  const handleSubmit = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()

    if (typeof onSubmit === 'function') {
      onSubmit(event)
    }
  }, [ onSubmit ])

  const Component = isFormular ? FormularField : Field

  // form with non-empty action is required by iOS 9+ to change keyboard type to 'Search'
  return (
    <form
      className={cx(className, s.container)}
      action="."
      onSubmit={handleSubmit}
      autoComplete="off"
    >
      <Component
        id="searchInput"
        autoComplete="off"
        inputRef={ref}
        beforeNode={beforeNode}
        {...rest}
      />
    </form>
  )
})


export default SearchField
